import StaticComparisonTable from "../../../../src/components/StaticComparisonTable";
import * as React from 'react';
export default {
  StaticComparisonTable,
  React
};